<template>
  <div class="components full-page-width">
    <h2 class="p-40">Icons</h2>
    <div class="row">
      <div class="col-xs-2 text-center m-b-40" v-for="(icon, index) in iconList" :key="`icon-${icon}-${index}`">
        <div class="relative bb">
          <span class="nn">{{ index + 1 }}</span>
          <Icon
            :name="icon"
            size="24"
            color="#000" />
          <span class="d-inline-block">{{ icon }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'Icons',
  data(){
    return{
      iconList: [
        'animation', 'airplane', 'arrowDown', 'arrowLeft', 'arrowUp', 'arrowRight', 'attach', 'agreements', 'arrowLeftBig',
        'building', 'barcode', 'bell', 'ban',
        'clock', 'checkMan', 'check', 'checkAll', 'calendar', 'code', 'coins', 'contacts', 'cloudDownload', 'cloudUpload', 'camera',
        'delivery', 'deliveryFast', 'deliveryTime', 'directionUp', 'deleteForever', 'document', 'dropdownArrow', 'dashboard', 'documentGoods',
        'energy', 'edit', 'editSquere', 'endOfDay',
        'filterTool', 'fileCopies', 'fuel',
        'gear',
        'hashMark',
        'info', 'images', 'insurance',
        'letter', 'listBullet', 'logout', 'link', 'load',
        'magnifier', 'menu',
        'network',
        'pen', 'phoneCall', 'preview', 'printer', 'printerLabel', 'plus', 'pin', 'pinPosition', 'pinWorld', 'pallet',
        'remove', 'restore', 'reply',
        'signature','success', 'single', 'star', 'stayHome', 'savedItems', 'scale', 'server', 'swapVertical',  'swapHorizontal', 'shipmentsAll', 'system', 'softBag', 'send',
        'triangle', 'truck', 'tag', 'todo', 'team', 'tube', 'temperature',
        'userLocation',
        'warning', 'warningSign',
        'zoomOut', 'pointer', 'products','loadingCircle'
      ],
    };
  },
};
</script>
